import { useSelector } from "react-redux";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Box, Button, useTheme } from "@mui/material";

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

import SearchIcon from '@mui/icons-material/Search';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

import { LightiningIcon } from "./../../../Icons";
import { LangChangeSelector, UserAvatar } from "../../home-header/header";
import { ColorModeContext, tokens, useMode } from '../../../theme/themeProvider';
import { MenuIemsContainner } from "../../home-header/common/menuItems";

import './dashboardHeader.scss';

export const DashboardHeader = ({ userData }) => {
  const loginState = useSelector((store) => store.maindata.loginState);

  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const colors = tokens(theme.palette.mode);

  let username = userData?.username || ''
  let firName = userData?.firstname || ''
  let lastname = userData?.lastname || ''

  const changeDarkLightMode = () => {
    console.log('mode', colors);
    colorMode.toggleColorMode();
  }

  return (
    <section
      className="d-cotent-header-section dashboard"
      style={{ backgroundColor: theme.palette.mode === 'dark' ? '#191919' : 'rgb(252, 252, 252)' }}
    >
      {/* <Box className='header-menu-wrapper'>
        <MenuIemsContainner customClassName={'dashboard'}/>
      </Box> */}
      {/* <Box className="dC-header-search-wrapper">
        <Box className="header-search-btn">
          <SearchIcon />
          <span>Search videos and folders</span>
        </Box>
      </Box> */}

      <Box className="dC-header-ActionContainer">
        <LangChangeSelector />
        <Button onClick={changeDarkLightMode}>
          {theme.palette.mode === "dark" && <LightModeIcon />}
          {theme.palette.mode === "light" && <DarkModeIcon />}
        </Button>

        <NavLink to='/pricing' className="ActionContainer-upgradeBtn">
          <span>{!!loginState ? 'Pricing' : 'Upgrade'}</span>
          <LightiningIcon />
        </NavLink>

        {/* <Box className="ActionContainer-inviteBtn">
          <span>Invite</span>
          <PersonAddAltOutlinedIcon />
        </Box> */}

        {/* <Box className="ActionContainer-questionBtn">
          <HelpOutlineOutlinedIcon />
        </Box> */}

        {/* <Box className="ActionContainer-notificationBtn">
          <NotificationsOutlinedIcon />
        </Box> */}

        <Box className="ActionContainer-userAvata-contain">
          <UserAvatar
            userData={userData}
            page='dashboard'
          />

          {/* {!userData?.picture && (
            <Box className="ActionContainer-user-Avata uppercase">
              {username.slice(0, 1)}
            </Box>
          )} */}
        </Box>
      </Box>
    </section>
  )
}